import { Requests } from "../requests";
import { schema, Params } from "./validator";

export const trackingFn = (requests: Requests) => async (params: Params) => {
  const validated = await schema.validate(params);
  const {
    event_type: eventType,
    isTestEvent,
    event_version: eventVersion,
    meta,
    attributes,
  } = validated;

  try {
    return await requests.post("/record", {
      params: {
        event_type: eventType,
        event_version: eventVersion,
        isTestEvent,
        meta,
        attributes,
      },
    });
  } catch (err) {
    if (
      err instanceof TypeError &&
      ((err as Error).message.toLowerCase().includes("networkerror") ||
        (err as Error).message.toLowerCase().includes("load failed") ||
        (err as Error).message.toLowerCase().includes("failed to fetch"))
    ) {
      // This likely happens when an adblocker blocks the tracking request, drop the error to prevent
      // Sentry pollution.
      return undefined;
    }

    if (
      (err instanceof DOMException &&
        (err as Error).message.toLowerCase().includes("aborted")) ||
      (err instanceof TypeError &&
        (err as Error).message.toLowerCase().includes("cancelled")) ||
      (err instanceof TypeError &&
        (err as Error).message.toLowerCase().includes("annulé"))
    ) {
      // This likely happens when a requests times out or is cancelled on the client, drop the error to prevent
      // Sentry pollution.
      return undefined;
    }

    throw err;
  }
};
